<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.1746 11.1758H12.8219V2.82305C12.8219 2.36802 12.4539 2 11.9988 2C11.5438 2 11.1758 2.36802 11.1758 2.82305V11.1758H2.82305C2.36802 11.1758 2 11.5438 2 11.9988C2 12.4539 2.36802 12.8219 2.82305 12.8219H11.1758V21.1746C11.1758 21.6296 11.5438 21.9976 11.9988 21.9976C12.4539 21.9976 12.8219 21.6296 12.8219 21.1746V12.8219H21.1746C21.6296 12.8219 21.9976 12.4539 21.9976 11.9988C21.9976 11.5438 21.6285 11.1758 21.1746 11.1758Z"
      :fill="iconColor"
    />
  </svg>
</template>

<script>
export default {
  name: "IconAdd",
  data: () => ({
    iconColor: "currentColor",
  }),
};
</script>
